// extracted by mini-css-extract-plugin
export default {"labels":"EnvelopeLabels_labels__O2ju3","label":"EnvelopeLabels_label__sQdpq","editor":"EnvelopeLabels_editor__to-aC","remove":"EnvelopeLabels_remove__nOHCB"};